export class ChoiceCancelledError extends Error {
    constructor() {
        super('Choice Set selection cancelled');
        this.name = 'ChoiceCancelledError';
    }
}
